import axios from "axios";

export const state = {
    productsmargin: [],
};

export const getters = {
    productsmargin: state => state.productsmargin,
};

export const mutations = {
    // setProductsMargin(productsmargin, newValue) { state.productsmargin = newValue},
    setProductsMargin(state, newValue) { state.productsmargin = newValue},

};

export const actions = {
    fetchProductsMargin({ commit }) {
        axios.get('/productsmargin').then(res => {
            commit('setProductsMargin', res.data.productMargins)
        })
    },
    filterProductsMargin({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterproductsmargin";
        axios.post(url, formData).then((response) => {
            commit('setProductsMargin', response.data.productMargins)
        })
    },
};
